import $ from 'jquery';
import WaitTimes from '@hpcare/component-wait-times';

export default function() {
	// This function simply bootstraps the React components
	$('.hp-wait-times').each(function() {
		ReactDOM.render(React.createElement(WaitTimes, $(this).data(), null), this);
	});
}



// WEBPACK FOOTER //
// ./src/webpack/widgets/wait-times.js